import PropTypes from "prop-types"
import React from "react"
import { Col, Card, CardBody } from "reactstrap"
import { Link, useHistory } from "react-router-dom"

const MiniWidget = ({ items }) => {
  
  const history = useHistory()
  const goToLink =(link) => {
    console.log('link:',link)
    history.push(link)
  }
  return (
    <React.Fragment>
      {items.map((item, key) => (
      
          <Col md="3" xs="6" key={key} className={"pointer-cursor-with-hover "} onClick={()=>goToLink(item.link)}>
            <Card className={item.clazz}>
              <CardBody>
                <div className="d-flex align-items-center my-3">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title rounded-circle bg-white bg-soft text-primary font-size-20">
                      <i className={item.icon} />
                    </span>
                  </div>
                  <h5 className="font-size-16 mb-0 text-white">{item.title}</h5>
                </div>
              </CardBody>
            </Card>
          </Col>
      ))}
    </React.Fragment>
  )
}

MiniWidget.propTypes = {
  reports: PropTypes.array,
}

export default MiniWidget
